var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.awardList.length > 0)?_c('award-list-link',{attrs:{"listLayout":_vm.listLayout,"awardList":_vm.awardList}}):_c('award-empty-link',{attrs:{"emptyLayout":_vm.emptyLayout}}),_c('pagination-link',{attrs:{"paginationLayout":_vm.paginationLayout}}),_c('judge-result-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }